import { validate as uuidValidate, version as uuidVersion, v4 as uuidv4 } from 'uuid';

// uuid cause issues with jest. YOU ARE WARNED !
export const getDeviceId = () => {
  let deviceId = localStorage.getItem('deviceId');

  if (deviceId && uuidValidate(deviceId) && uuidVersion(deviceId) === 4) {
    return deviceId;
  }

  deviceId = uuidv4();
  localStorage.setItem('deviceId', deviceId);

  return deviceId;
};
